<style lang="scss" scoped>
@import "$vars";
@screen mobile {
  .patient_profile {
    @apply p-0 w-full py-6 mb-0 mt-8 #{!important};
    figcaption {
      h2 {
        @apply absolute ml-2 left-0;
        margin-top: -2rem;
      }
    }
    img {
      @apply m-0 mr-4;
      max-width: 7em;
    }
  }
}
.patient_profile {
  @apply flex;
  h2 {
    font-size: 1.4rem;
  }
  li {
    font-size: 0.8rem;
    margin-top: 0.1rem;
  }
  img {
    @apply rounded mr-8 w-full h-auto self-center;
    max-width: 160px;
  }
}
</style>

<template>
  <div>
    <figure class="patient_profile">
      <img :src="profilePicture" />
      <figcaption>
        <h2>{{patientName}}</h2>
        <ul class="list-unstyled" >
          <li class="personalData" v-for="(field, $index) of patientData" :key="$index" v-show="field.value">
            {{ field.label }}:
            <strong v-if="!/(e-?mail)/gi.test(field.label)" class="capitalize">
              {{ field.value | toLowerCase | REMOVE_UNDERSCORE }}
            </strong>
            <strong v-else>
              {{ field.value }}
            </strong>
          </li>
        </ul>
      </figcaption>
    </figure>

    <medical-record-controls :patient="patient"/>
  </div>
</template>

<script>
import medicalRecordControls from '@/components/layout/appointments/medicalRecord'

export default {
  name: 'DrPatientDetailsHeader',

  filters: {
    toLowerCase: function (value) {
      if (!value) {
        return ''
      }
      return value.toString().toLowerCase().replace('convenio', 'Convênio')
    }
  },

  props: {
    doctor: {
      type: Object,
      require: true
    },

    patient: {
      type: Object,
      require: true
    },

    appointment: {
      type: Object,
      require: true
    },

    appointments: {
      type: Array,
      require: true
    },

    hasAppointment: {
      type: Boolean,
      default: false
    },

    showMedicalRecordControls: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },

  components: {
    medicalRecordControls
  },

  data () {
    return {
      patientName: null,
      patientData: {
        gender: {
          label: 'Sexo',
          value: null
        },
        age: {
          label: 'Idade',
          value: null
        },
        firstAppointment: {
          label: 'Primeira consulta em',
          value: null
        },
        type: {
          label: 'Tipo de consulta',
          value: null
        },
        health_insurance: {
          label: 'Plano',
          value: null
        },
        contact_phone: {
          label: 'Telefone',
          value: null
        },
        email: {
          label: 'E-mail',
          value: null
        }
      },
      loading: false,
      profilePicture: require('@/assets/img/m_default.png')
    }
  },

  watch: {
    'patient.id': {
      deep: true,
      immediate: false,
      handler (id) {
        if (id) {
          this.getPatientProfilePicture()
        }
      }
    },

    shouldGetUserFiles: {
      deep: false,
      immediate: false,
      handler (value) {
        if (value) {
          this.getPatientSharedFiles(this.patient.id)
        }
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    updateAppointment (clinicalEvaluation = null) {
      if (clinicalEvaluation) {
        const {
          diagnosticAnalysis,
          diagnosticHypothesis,
          finalDiagnostic,
          mainComplaint
        } = clinicalEvaluation

        this.appointment['diagnostic_analysis'] = diagnosticAnalysis
        this.appointment['diagnostic_hypothesis'] = diagnosticHypothesis
        this.appointment['final_diagnostic'] = finalDiagnostic
        this.appointment['main_complaint'] = mainComplaint
      }
    },

    init () {
      this.getPatientProfilePicture()
      for (const field in this.patientData) {
        this.patientData[field].value = null
      }
      const patient = this.patient

      this.patientName = patient.name
      this.patientData.gender.value = patient.gender === 'M' ? 'Masculino' : patient.gender === 'F' ? 'Feminino' : 'Não informado'
      this.patientData.age.value = this.$moment().diff(patient.date_of_birth, 'years', false)
      if (this.appointments.length > 0) {
        this.patientData.firstAppointment.value = this.fn_FROM_SERVER_DATE(this.appointments[0].appointment_finish) + `, ${this.appointments.length} atendimento${this.appointments.length === 1 ? '' : 's'}`
      }
      if (this.hasAppointment) {
        this.patientData.type.value = this.appointment.type
      }
      this.patientData.contact_phone.value = this.$root.$options.filters.TO_TEL(patient.contact_phone)
      this.patientData.email.value = patient.email
      if (this.patientData.type.value === 'CONVENIO') {
        this.$http.get(`/doctor/agenda?filterAnd[a.id]=${this.appointment.id}`, this.$store.getters.getAuthHeader).then(
          (res) => {
            const agenda = res.data.data
            this.patientData.health_insurance.value = agenda[0].healthInsuranceName
          }
        )
      }
    },

    getPatientProfilePicture () {
      if (this.$route.params.patientType === 'patient') {
        const url = `/s3/file/user/${this.patient.id}/profile_picture`

        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then(() => (this.profilePicture = `${process.env.ROOT_API}${url}`))
          .catch(() => (this.profilePicture = this.fn_GET_AVATAR(this.patient)))

        return
      }

      this.profilePicture = this.fn_GET_AVATAR(this.patient)
    },

    getPatientSharedFiles (patientId = null) {
      if (patientId) {
        const endpoint = `/doctor/patient/${patientId}/user_medical_exam`

        this.$http.get(endpoint, this.$store.getters.getAuthHeader)
          .then((res) => {
            this.patientMedicalFiles = res.data
          })
      }
    }
  }
}
</script>
